<template>
  <div class="student">
    <div class="main-wrap">
      <div id="main-content">
        <div class="wrapper">
          <div class="table-agile-info">
            <jm-crumbs/>
            <el-row class="searchForm" :gutter="10">
              <el-col :span="8">
                国家：
                <el-select v-model="searchData.sh_country" placeholder="请选择" @change="changeCountry">
                  <el-option
                    v-for="item in ds.country"
                    :key="item.sh_country"
                    :label="item.title"
                    :value="item.sh_country"/>
                </el-select>
              </el-col>
              <el-col :span="8">
                毕业院校：
                <jm-Search
                  clearable
                  v-model="schoolCN"
                  get-value="name"
                  get-type="sh_name_cn"
                  country-id="0"
                  :is-doble="true"
                  get-url='/index/api_base/searchGSchool'
                />
              </el-col>
              <el-col :span="8">
                课程类型：
                <el-select v-model="searchData.attention">
                  <el-option
                    v-for="item in ds.attention.filter(item => { return item.pid === searchData.sh_country })"
                    :key="item.id"
                    :label="item.value"
                    :value="item.id"/>
                </el-select>
              </el-col>
              <el-col :span="8">
                专业名称：<el-input class="jm-input220" v-model="searchData.pf_name"/>
              </el-col>
              <el-col :span="8">
                最小均分：<el-input class="jm-input220" v-model="searchData.min_result"/>
              </el-col>
            </el-row>
            <el-row class="jm-tac" :gutter="10">
              <el-col :span="24">
                <el-button type="primary" @click="init">搜索</el-button>
              </el-col>
            </el-row>
            <jm-tableList
              v-if="searchData"
              url="/index/u_u_college_rule/getList"
              :refresh="refresh"
              :search-data="searchData">
              <el-table-column
                slot="firstColumn"
                type="expand">
                <template slot-scope="props">
                  <el-row>
                    <el-col class="pfList" :span="6" v-for="(item,index) in props.row.pf_list" :key="index">
                      <a :href="item.pf_url" :title="item.pf_name" target="_blank">{{ item.pf_name }}</a>
                    </el-col>
                  </el-row>
                </template>
              </el-table-column>
              <el-table-column
                slot="min_result"
                slot-scope="scope"
                v-bind="scope.attrs"
                :label="scope.label"
                property="min_result">
                <template slot-scope="scope">
                  {{ scope.row.min_result }}
                  <span class="blue" v-if="scope.row.stand_result !== ''">({{ scope.row.stand_result }})</span>
                </template>
              </el-table-column>
            </jm-tableList>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { jmSearch } from '@/components/tool';
import jmTableList from '@/components/data/tableList';

export default {
  data() {
    return {
      ds: {},
      refresh: false,
      schoolCN: {},
      searchData: {
        cn_sh_name: '',
        min_result: '',
        sh_country: 1,
        pf_name: '',
        attention: ''
      },
      cms_country: 0,
      timeout: null,
    };
  },
  components: { jmTableList, jmSearch },
  created() {
    this.$http
      ._get({
        url: '/index/u_u_college_rule/searchDict'
      })
      .then(({ data }) => {
        this.ds = Object.assign({}, this.ds, data);
        this.searchData.sh_country = typeof this.ds.country === 'object' ? this.ds.country[0].sh_country : 1;
        this.cms_country = typeof this.ds.country === 'object' ? this.ds.country[0].cms_country : 30;
        this.searchData.attention = '';
        this.ds.attention.forEach((i) => {
          if (i.pid === this.searchData.sh_country && i.value === '硕士') {
            this.searchData.attention = i.id;
          }
        });
        this.init();
      });
  },
  methods: {
    init() {
      this.searchData.cn_sh_name = this.schoolCN.name;
      console.log(this.searchData.cn_sh_name);
      this.$store.commit('updateRefresh', true);
    },
    setChartsSort() {
      this.chartsData = this.sortData(this.chartsData, this.chartsSort.value);
    },
    changeCountry() {
      this.ds.country.forEach((i) => {
        if (this.searchData.sh_country === i.sh_country) {
          this.cms_country = i.cms_country;
          this.searchData.attention = '';
          this.ds.attention.forEach((i) => {
            if (i.pid === this.searchData.sh_country && i.value === '硕士') {
              this.searchData.attention = i.id;
            }
          });
        }
      });
    },
  },
  watch: {
    // schoolCN() {
    //   this.searchData.cn_sh_name = '';
    //   if (this.schoolCN.name) {
    //     this.searchData.cn_sh_name = this.schoolCN.name;
    //   }
    // }
  }
};

</script>

<style scoped>
#main-content {
  background-color: #f3f3f3;
}

.s_right {
  float: right;
}

.searchForm *{
  padding: 5px;
}

.rows {
  margin-top: 10px;
  margin-bottom: 30px;
}

.rows .rows-div {
  background-color: #FFF;
  border-radius: 5px;
  padding: 10px 20px 20px 20px;
}

.rows .rows-div p {
  border-bottom: solid 1px #CCC;
  padding: 10px 0px;
}

.rows .rows-div .chart-div {
  height: 250px;
}

.s_title {
  font-size: 18px;
}

.blue {
  color: #409EFF;
}
.pfList {
  padding: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
